/* ==========================================================================
   MONSERANT - Galerie produit filtrée par patine / couleur
   --------------------------------------------------------------------------
   Objectif : au clic sur une couleur, la galerie n'affiche que les photos
   de cette couleur (photo principale + vignettes).

   Règle appliquée, sans aucune saisie manuelle :
   les photos d'une couleur = l'image assignée à la variante dans l'admin
   Shopify + toutes les images qui la suivent dans la galerie, jusqu'à
   l'image assignée à la couleur suivante.

   Conséquence pratique : pour piloter l'affichage, il suffit dans l'admin
   Shopify de ranger les photos par couleur, dans l'ordre, et d'assigner à
   chaque variante la PREMIÈRE photo de son groupe. C'est déjà le cas sur la
   majorité du catalogue.

   Thème : compatible Dawn (media-gallery / slider-component / variant-selects).
   Le script ne fait rien si le produit n'a pas d'images de variante.
   ========================================================================== */
(function () {
  'use strict';

  var CACHE = null;
  var busy = false;
  var timers = [];
  var REVEAL_MS = 1500; // sécurité : on réaffiche tout si le script échoue

  /* ---------- anti-clignotement : on masque les vignettes le temps du calcul */
  function maskThumbs() {
    var style = document.createElement('style');
    style.id = 'ms-gallery-mask';
    style.textContent =
      '.product__media-wrapper:not(.ms-ready) .thumbnail-list__item{opacity:0;transition:opacity .15s}' +
      '.product__media-wrapper.ms-ready .thumbnail-list__item{opacity:1}';
    document.head.appendChild(style);
    setTimeout(reveal, REVEAL_MS);
  }
  function reveal() {
    var w = document.querySelector('.product__media-wrapper');
    if (w) w.classList.add('ms-ready');
  }

  /* ---------- lecture des données produit ---------------------------------- */
  function handle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function index(p) {
    var media = p.media.slice().sort(function (a, b) { return a.position - b.position; });
    var order = media.map(function (m) { return String(m.id); });

    var byVariant = {};   // id de variante        -> id de la 1re image du groupe
    var optionSets = {};  // valeur d'option       -> images de tête rencontrées
    var starts = [];

    p.variants.forEach(function (v) {
      if (!v.featured_media) return;
      var head = String(v.featured_media.id);
      byVariant[String(v.id)] = head;
      if (starts.indexOf(head) === -1) starts.push(head);
      (v.options || []).forEach(function (val) {
        var key = String(val).trim();
        if (!optionSets[key]) optionSets[key] = [];
        if (optionSets[key].indexOf(head) === -1) optionSets[key].push(head);
      });
    });

    // on ne garde que les valeurs d'option qui désignent UNE seule image de tête
    // (c'est l'option couleur ; la taille est écartée automatiquement)
    var byOption = {};
    Object.keys(optionSets).forEach(function (k) {
      if (optionSets[k].length === 1) byOption[k] = optionSets[k][0];
    });

    starts.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });

    var blocks = {};
    starts.forEach(function (head, i) {
      var from = order.indexOf(head);
      var to = (i + 1 < starts.length) ? order.indexOf(starts[i + 1]) : order.length;
      blocks[head] = order.slice(from, to);
    });

    return { order: order, byVariant: byVariant, byOption: byOption, blocks: blocks, count: starts.length };
  }

  function load() {
    var h = handle();
    if (!h) return Promise.resolve(null);
    return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return p ? index(p) : null; })
      .catch(function () { return null; });
  }

  /* ---------- quel groupe d'images afficher ? ------------------------------ */
  function currentHead() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && CACHE.byVariant[input.value]) return CACHE.byVariant[input.value];

    // repli : combinaison taille + couleur indisponible, donc pas de variante.
    // On se base alors sur la couleur cochée pour garder la galerie cohérente.
    var picked = [];
    document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked')
      .forEach(function (i) { picked.push(i.value.trim()); });
    document.querySelectorAll('variant-selects select, variant-radios select')
      .forEach(function (s) { if (s.value) picked.push(s.value.trim()); });

    for (var i = picked.length - 1; i >= 0; i--) {
      if (CACHE.byOption[picked[i]]) return CACHE.byOption[picked[i]];
    }
    return null;
  }

  function shortId(str) { return (str || '').split('-').pop(); }

  function apply() {
    if (!CACHE || busy) return;
    var gal = document.querySelector('media-gallery');
    if (!gal || !gal.elements || !gal.elements.viewer) return; // galerie en cours de rendu
    var head = currentHead();
    if (!head) { reveal(); return; }
    var visible = CACHE.blocks[head] || [];
    if (!visible.length) { reveal(); return; }

    busy = true;

    document.querySelectorAll('.product__media-item').forEach(function (el) {
      el.style.display = visible.indexOf(shortId(el.dataset.mediaId)) !== -1 ? '' : 'none';
    });
    document.querySelectorAll('.thumbnail-list__item').forEach(function (el) {
      el.style.display = visible.indexOf(shortId(el.dataset.target)) !== -1 ? '' : 'none';
    });

    // si la photo actuellement affichee appartient a une autre couleur,
    // on bascule sur la premiere photo du groupe.
    // On le fait nous-memes plutot que via le theme : le theme programme un
    // scroll differe qui plante quand il reconstruit la galerie au meme moment.
    var viewer = gal.elements.viewer;
    var active = viewer.querySelector('[data-media-id].is-active');
    var activeId = active ? shortId(active.dataset.mediaId) : null;

    if (!activeId || visible.indexOf(activeId) === -1) {
      var target = viewer.querySelector('[data-media-id$="-' + visible[0] + '"]');
      if (target) {
        viewer.querySelectorAll('[data-media-id]').forEach(function (el) { el.classList.remove('is-active'); });
        target.classList.add('is-active');
        try { if (target.parentElement) target.parentElement.scrollTo({ left: target.offsetLeft }); } catch (e) {}

        var thumbs = gal.elements.thumbnails;
        if (thumbs) {
          thumbs.querySelectorAll('button').forEach(function (b) { b.removeAttribute('aria-current'); });
          var tb = thumbs.querySelector('[data-target$="-' + visible[0] + '"] button');
          if (tb) tb.setAttribute('aria-current', 'true');
          try { if (thumbs.slider) thumbs.slider.scrollTo({ left: 0 }); } catch (e) {}
        }
      }
    }

    // on recalcule la pagination des carrousels sur le nombre reduit de photos
    [gal.elements.viewer, gal.elements.thumbnails].forEach(function (s) {
      try { if (s && s.slider && typeof s.initPages === 'function') s.initPages(); } catch (e) {}
    });

    reveal();
    setTimeout(function () { busy = false; }, 60);
  }

  function schedule() {
    timers.forEach(clearTimeout);
    timers = [0, 120, 350, 800].map(function (d) { return setTimeout(apply, d); });
  }

  /* ---------- démarrage ---------------------------------------------------- */
  function start() {
    var wrapper = document.querySelector('.product__media-wrapper');
    if (!wrapper) return;
    maskThumbs();

    load().then(function (data) {
      if (!data || data.count < 2) { reveal(); return; }
      CACHE = data;
      schedule();

      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest &&
            e.target.closest('.product-form__input, variant-selects, variant-radios')) schedule();
      });

      // le thème réinjecte la galerie à chaque changement de variante :
      // on réapplique le filtre après chaque reconstruction
      var root = wrapper.closest('[id^="shopify-section"]') || document.body;
      new MutationObserver(function () { if (!busy) schedule(); })
        .observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();